import { ArrayLoading } from '@/store/types'

import { loading, none } from '@/store/constants'

import {
  ActiveDivision, Division,
} from './types'

import { active, blankEditBase } from '@/store/editor/constants'

import _ from 'lodash'

export const blankDivision: Division = _.merge({
  DivisionName: '',
  DisplayName: '',
  OEM: false,
}, blankEditBase)

export const noneDivision: Division = _.assign({}, blankDivision, none)

export const loadingDivision: ArrayLoading<Division> = _.assign([], blankDivision, loading)

export const activeDivisionNone: ActiveDivision = _.assign({}, noneDivision, active, none)
